export interface Organization {
  createdAt?: string;
  id: string;
  name: string;
  language: string;
  groupId?: string;
  admin?: Admin;
  logoUrl?: string;
  updatedAt?: string;
  origin: OriginType;
  config?: OrganizationConfig;
  createdBy?: CreatedBy;
}

export interface Admin {
  id: string;
  email: string;
  userName: string;
  userRoles: string[];
}

export enum OriginType {
  ALGOAN = 'ALGOAN',
  ADMIN = 'ADMIN',
  CONSOLE = 'CONSOLE',
}

export interface OrganizationConfig {
  subscriptionPlan?: SubscriptionPlan;
  subscriptionPlanRequest?: SubscriptionPlanRequest;
  notifyUsersOnEveryAnalysisCreated?: boolean;
}

export interface SubscriptionPlan {
  name: SubscriptionPlanName;
  totalApiQuotaForEachSandboxProject: number;
  monthlyApiQuotaForAllLiveProjects: number;
  numberOfDashboardLicenses?: number;
}

export enum SubscriptionPlanName {
  STARTER = 'FREE',
  PRO = 'PRO',
  ENTERPRISE = 'ENTERPRISE',
}

export interface SubscriptionPlanRequest {
  planName: SubscriptionPlanName;
  status: SubscriptionPlanStatus;
}

export enum SubscriptionPlanStatus {
  PENDING = 'PENDING',
  VALIDATED = 'VALIDATED',
  REFUSED = 'REFUSED',
}

export interface CreatedBy {
  email: string;
  firstName: string;
  lastName: string;
}
